import React from "react";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";
import CircularProgress from "@material-ui/core/CircularProgress";
import { dispatch, connect } from "../recontext/store";
import { api } from "../services/index";

const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
    borderRadius: 8,
    background: "#ff4566",
    boxShadow:
      "0 10px 34px rgba(255,68,102,.4), 0 2px 16px rgba(255,68,102,.2);"
  },
  leftIcon: {
    marginRight: theme.spacing.unit
  }
});

class ButtonJoin extends React.PureComponent {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.state = { loading: false };
  }

  async handleClick() {
    const { teamId, user } = this.props;
    if (!user) {
      return dispatch("SHOW_LOGIN_DIALOG");
    }

    this.setState({
      loading: true
    });

    await api.likeTeam(teamId);
    this.setState({
      loading: false
    });
  }

  render() {
    const { classes, user, teamId, teams, teamLikers } = this.props;
    const { loading } = this.state;
    const userId = user ? user.id : null;

    const isMyTeam = userId && userId === teamId;
    const inOtherTeam = userId && userId !== user.teamId;
    const someOneInTeam =
      userId && teams[userId] && teams[userId].members.length > 1;
    const isMaxUser = teams[teamId] && teams[teamId].members.length === 5;

    const myTeamLikers = (userId && teamLikers[user.teamId]) || [];
    const isLikedMyTeam = myTeamLikers.indexOf(teamId) > -1;

    if (isMyTeam || inOtherTeam || someOneInTeam || isMaxUser || isLikedMyTeam)
      return null;

    const likers = teamLikers[teamId] || [];
    const isSent = userId && likers.indexOf(userId) > -1;

    return (
      <Button
        variant="contained"
        color="secondary"
        className={classes.button}
        onClick={this.handleClick}
        disabled={isSent || loading}
      >
        {loading ? (
          <CircularProgress className={classes.leftIcon} size={24} />
        ) : (
          <Icon className={classes.leftIcon}>
            {isSent ? "thumb_up" : "favorite"}
          </Icon>
        )}
        {isSent ? "Waiting" : "Team Up"}
      </Button>
    );
  }
}

const mapStateToProps = state => ({
  teams: state.teams,
  teamLikers: state.teamLikers,
  user: state.user
});

export default connect(mapStateToProps)(withStyles(styles)(ButtonJoin));
